import AppSystemPagingResultModelBase from '../_generated/modelBases/app-system-paging-result-model-base';

export default class AppSystemPagingResultModel extends AppSystemPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
